import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Service } from "../service.class";
import { ToolModel } from "../../../shared/entities/tool.model";

@Injectable({
	providedIn: "root",
})
export class ToolsService {
	private server_path: string = "/v2/products";

	constructor(private service: Service) {}

	public postToolModel(f: ToolModel): Observable<ToolModel> {
		return this.service.apiPostWithoutHeaders(this.server_path, f);
	}

	public getToolModelById(id: string): Observable<ToolModel> {
		return this.service.apiGetWithoutHeaders(this.server_path + "/" + id, {
			paginate: false,
		});
	}
	public deleteToolModelById(id: string): Observable<ToolModel> {
		return this.service.apiDelete(this.server_path + "/" + id);
	}
	public getToolsModels(query: any): Observable<ToolModel> {
		return this.service.apiGetWithoutHeaders(this.server_path, {
			paginate: true,
			...query,
		});
	}

	public updateToolModelById(id: string, tool: ToolModel): Observable<ToolModel> {
		return this.service.apiPut(this.server_path + "/" + id, tool);
	}
}
